import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const history = useHistory();
  const location = useLocation();
  const [secs, setSecs] = useState(8);

  useEffect(() => {
    const tick = setInterval(() => setSecs(s => (s > 0 ? s - 1 : 0)), 1000);
    const timer = setTimeout(() => history.replace('/'), 5000);
    return () => { clearInterval(tick); clearTimeout(timer); };
  }, [history]);

  return (
    <main className="nf-wrapper" aria-labelledby="nf-title">
      <h1 id="nf-title" className="nf-title">404</h1>
      <p className="nf-subtitle">Página no encontrada</p>

      <p className="nf-detail">
        No pudimos encontrar <code className="nf-code">{location.pathname}</code>.
      </p>

      <div className="nf-actions">
        <button className="nf-btn" onClick={() => history.goBack()}>
          Volver atrás
        </button>
        <Link className="nf-btn nf-btn-primary" to="/">
          Ir al inicio
        </Link>
      </div>

      <p className="nf-timer">Redirigiendo al inicio en {secs}…</p>
    </main>
  );
};

export default NotFound;
